import { BackButtonT1 } from "Components/Common/Button/index";
import { Spacer } from "Components/Common/Spacer/index";
import { PageWrapperT2 } from "Components/Common/Wrapper/PageWrapper";
import FilterBox from "Components/RateComparison/MultimodalRateComparison​/FilterBox";
import FreightInformationCard from "Components/RateComparison/MultimodalRateComparison​/FreightInformationCard";
import ViewDetailsAccordion from "Components/RateComparison/MultimodalRateComparison​/ViewDetailsAccordion";
import {
  BidDetailsTableInformation,
  PaginationButtons,
  RateComparisonTable,
} from "Components/RateComparison/MultimodalRateComparison​/index";

import Sticky from "Components/Sticky/index";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import ActionBlurLoader from "Components/ActionLoader/LoaderWithBlur";

import {
  GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST,
  GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST,
  GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST,
  GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST,
  GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST,
  GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST,
  GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST,
  GET_ORIGIN_DESTINATION_YARD_LIST,
  GET_RAIL_RAKE_LIST,
  SET_DETAILED_CALCULATION_FOR_RAIL_FREIGHT,
} from "Constants/actionConstants";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import Message from "Components/Common/Message/Message";
import ModalCardT1 from "Components/RateComparison/CalculationForFreight/ModalCardT1";
import ModalT1 from "Components/Common/Modal/ModalT1";
import DetailedCalculationForFreight from "./DetailedCalculationForFreight​";


class MultimodalRateComparison extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAccordionOpen: true,
      filterQueryParams: {
        from: null,
        to: null,
      },
      limit: 4,
      offset: 0,
      activePage: 1,
      avgFreight: {
        value: 30,
        label: "Last 30 Days Avg."
      },
      vehicleType: null,
      wagonType: {
        label: "42 MT",
        value: 42,
        id: 1,
        wagon: 42
      },
      railRake: {
        name: "Full Rake",
        id: 1,
        label: "Full Rake",
        value: "Full Rake"
      },
      isMoreFilterOpen: false,
      originYard: null,
      destinationYard: null,
      commodityCategory: {
        label: "HYDROGENATED AND OTHER EDIBLE OILS",
        value: "HYDROGENATED AND OTHER EDIBLE OILS"
      },
      isModalPopupOpen: false,
      selectedRoadFreight: {},
      isDetailedCalculationModalPopupOpen: false,
      RFRLimit: 20,
      RFROffset: 0,
      RAFRLimit: 30,
      RAFROffset: 0,
      activePageRFR: 1,
      activePageRAFR: 1,
    };
  }

  componentDidMount() {
    this.handleGetMultimodeRateComparisonSoureDestinationList();
    this.handleGetMultimodeRateComparisonCommodityCategoryList();
    this.handleGetMultimodeRateComparisonFreightRateList();
    this.handleGetMultimodeRateComparisonFreightDaysList();
    this.handleGetMultimodeRateComparisonVehicleDetailsList();
    this.handleGetRailRakeList();
    this.handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList();
    this.handleGetMultimodeRateComparisonViewDetailsRailFreightRateList();
    this.handleGetOriginDestinationYardList();
  }

  componentDidUpdate(prevProps, prevState) {

    const {
      avgFreight,
      vehicleType,
      offset,
      wagonType,
      railRake,
      originYard,
      destinationYard,
      commodityCategory,
      filterQueryParams,
      RFROffset,
      RAFROffset
    } = this.state;

    const {
      vehicleDetails,
      originYardList,
      destinationYardList,
      source,
      destination
    }=this.props

    if (
      prevState.avgFreight !== avgFreight ||
      prevState.vehicleType !== vehicleType
    ) {
      this.handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList();
    }

    if (
      prevState.railRake !== railRake ||
      prevState.wagonType !== wagonType ||
      prevState.originYard !== originYard ||
      prevState.destinationYard !== destinationYard ||
      prevState.commodityCategory !== commodityCategory
    ) {
      this.handleGetMultimodeRateComparisonViewDetailsRailFreightRateList();
    }

    // if (prevState.offset !== offset) {
    //   this.handleGetMultimodeRateComparisonFreightRateList();
    // }

    // if(prevProps.vehicleDetails !== vehicleDetails){
    //   this.handleOnChangeVehicleType([vehicleDetails[0]])
    // }
    if(prevProps.source !== source || prevProps.destination !== destination ){
      this.handleFilterBoxOnChange(source[0],'from')
      this.handleFilterBoxOnChange(destination[0],'to')
    }

    if(prevProps.originYardList !== originYardList){
      this.handleOnChangeOriginYard(originYardList[0])
      this.handleOnChangeDestinationYard(destinationYardList[0])
    }

    if(prevState.filterQueryParams !== filterQueryParams){
      this.handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList()
      this.handleGetMultimodeRateComparisonViewDetailsRailFreightRateList()
      this.handleGetMultimodeRateComparisonFreightRateList()
    }
    // if(prevState.RFROffset !== RFROffset){
    //   this.handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList()
    // }
    // if(prevState.RAFROffset !== RAFROffset){
    //   this.handleGetMultimodeRateComparisonViewDetailsRailFreightRateList()
    // }
  }

  handleGetMultimodeRateComparisonSoureDestinationList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST,
      
    });
  };
  handleGetMultimodeRateComparisonCommodityCategoryList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST,
    });
  };
  handleGetMultimodeRateComparisonFreightRateList = () => {
    const { limit, offset, filterQueryParams, commodityCategory } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST,
      payload: {
        queryParams: {
          limit,
          offset,
          from: !!filterQueryParams.from ? filterQueryParams.from.value : null,
          to: !!filterQueryParams.to ? filterQueryParams.to.value : null,
          // commodityCategory: !!commodityCategory
          //   ? commodityCategory.value
          //   : null,
        },
      },
    });
  };
  handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList = () => {
    const { dispatch } = this.props;
    const { avgFreight, filterQueryParams, vehicleType,
      RFRLimit,
      RFROffset
     } = this.state;
    const avgFreightValue = (avgFreight || {}).value;
    const updateVehicleType =
      !!vehicleType && vehicleType.length !== 0
        ? vehicleType.map((ele) => ele.value).join(",")
        : null;
    dispatch({
      type: GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST,
      payload: {
        queryParams: {
          avgFreight: avgFreightValue,
          vehicleType: updateVehicleType,
          from: !!filterQueryParams.from ? filterQueryParams.from.value : null,
          to: !!filterQueryParams.to ? filterQueryParams.to.value : null,
          limit:RFRLimit,
          offset:RFROffset,
        },
      },
    });
  };
  handleGetMultimodeRateComparisonViewDetailsRailFreightRateList = () => {
    const { dispatch } = this.props;

    const {
      wagonType,
      filterQueryParams,
      railRake,
      originYard,
      destinationYard,
      commodityCategory,
      RAFRLimit,
      RAFROffset
    } = this.state;
    const wagonWt = (wagonType || {}).value;
    const rakeName = (railRake || {}).value;
    dispatch({
      type: GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST,
      payload: {
        queryParams: {
          rakeName,
          wagonWt,
          originYard: (originYard || {}).value,
          destinationYard: (destinationYard || {}).value,
          from: !!filterQueryParams.from ? filterQueryParams.from.value : null,
          to: !!filterQueryParams.to ? filterQueryParams.to.value : null,
          commodityCategory: !!commodityCategory
            ? commodityCategory.value
            : null,
            limit:RAFRLimit,
            offset:RAFROffset
        },
      },
    });
  };
  handleGetMultimodeRateComparisonFreightDaysList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST,
    });
  };
  handleGetMultimodeRateComparisonVehicleDetailsList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST,
    });
  };
  handleGetOriginDestinationYardList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_ORIGIN_DESTINATION_YARD_LIST,
    });
  };
  handleGetRailRakeList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_RAIL_RAKE_LIST,
    });
  };

  handleOnClickForRateComparisonTableItems = (data) => {
    const { history } = this.props;
    const { dispatch } = this.props;

    dispatch({
      type: SET_DETAILED_CALCULATION_FOR_RAIL_FREIGHT,
      payload: data,
    });
    setItemToSessionStorage("detailedCalculationForRailFreight", data);
    // history.push("/detailedCalculationForFreight");
    this.handleOpenDetailedCalculationModalPopup()
  };
  handleOnClickBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  toggleAccordionOpenClose = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isAccordionOpen: !previousState.isAccordionOpen,
      };
      return updatepreviousState;
    });
  };

  handleFilterBoxOnChange = (value, name) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        filterQueryParams: {
          ...prevState.filterQueryParams,
          [name]: value,
        },
        offset:0,
        activePage:1,
        RFROffset: 0,
        activePageRFR: 1,
        RAFROffset: 0,
        activePageRAFR: 1,
      };
    });
  };

  handleOnClickForFilterBoxSearchButton = () => {
  this.setState((prevState) => {
    const updatedState = {...prevState};
    updatedState.offset=0
    updatedState.activePage=1
    updatedState.RFROffset= 0
    updatedState.activePageRFR= 1
    updatedState.RAFROffset= 0
    updatedState.activePageRAFR= 1
    return updatedState
  },
  ()=>{
    this.handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList();
    this.handleGetMultimodeRateComparisonViewDetailsRailFreightRateList();
    this.handleGetMultimodeRateComparisonFreightRateList();
  });
  };
  
  handleOnChangeAvgFreight = (value) => {
    this.setState({
       avgFreight: value,
       RFROffset: 0,
       activePageRFR:1
    });
  };
  handleOnChangeVehicleType = (value) => {
    this.setState({ 
      vehicleType: value,
      RFROffset: 0,
      activePageRFR:1
     });
  };
  handleOnChangeWagonType = (value) => {
    this.setState({
       wagonType: value ,
       RAFROffset:0,
       activePageRAFR: 1,
      });
  };
  handleOnChangeRailRake = (value) => {
    this.setState({ 
      railRake: value,
      RAFROffset:0,
      activePageRAFR: 1,
     });
  };
  handleOnChangeOriginYard = (value) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.originYard = value
      updateState.RAFROffset = 0;
      updateState.activePageRAFR = 1;
      return updateState;
    });
  };
  handleOnChangeDestinationYard = (value) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.destinationYard = value;
      updateState.RAFROffset = 0;
      updateState.activePageRAFR = 1;
      return updateState;
    });
  };
  handleOnChangeCommodityCategory = (value) => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.commodityCategory = value;
      updateState.RAFROffset = 0;
      updateState.activePageRAFR = 1
      return updateState;
    });
  };
  handleOnClickPreviousPage = () => {
    const { limit, activePage } = this.state;
    if (activePage === 1) {
      return;
    }
    const updateActivePage = activePage - 1;
    const updateOffset = updateActivePage * limit - limit;
    this.setState({ 
      offset: updateOffset, 
      activePage: updateActivePage
     },
     ()=>{
      this.handleGetMultimodeRateComparisonFreightRateList();
     }
     );
  };
  handleOnClickNextPage = () => {
    const { limit, offset, activePage } = this.state;
    const updateActivePage = activePage + 1;
    const updateOffset = updateActivePage * limit - limit;
    this.setState({
       offset: updateOffset,
        activePage: updateActivePage
       },
       ()=>{
        this.handleGetMultimodeRateComparisonFreightRateList();
       }
       );
  };

  handleOnClickRFRPreviousPage = () => {
    const { RFRLimit, activePageRFR } = this.state;
    if (activePageRFR === 1) {
      return;
    }
    const updateActivePage = activePageRFR - 1;
    const updateOffset = updateActivePage * RFRLimit - RFRLimit;
    this.setState({
      RFROffset: updateOffset,
      activePageRFR: updateActivePage
    },
      () => {
        this.handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList()
      }
    );
  };
  handleOnClickRFRNextPage = () => {
    const { RFRLimit, activePageRFR } = this.state;
    const updateActivePage = activePageRFR + 1;
    const updateOffset = updateActivePage * RFRLimit - RFRLimit;
    this.setState({
       RFROffset: updateOffset,
        activePageRFR: updateActivePage
      },()=>{
        this.handleGetMultimodeRateComparisonViewDetailsRoadFreightRateList()
      });
  };

  handleOnClickRAFRPreviousPage = () => {
    const { RAFRLimit, activePageRAFR } = this.state;
    if (activePageRAFR === 1) {
      return;
    }
    const updateActivePage = activePageRAFR - 1;
    const updateOffset = updateActivePage * RAFRLimit - RAFRLimit;
    this.setState({ 
      RAFROffset: updateOffset, 
      activePageRAFR: updateActivePage,
     },
     ()=>{
      this.handleGetMultimodeRateComparisonViewDetailsRailFreightRateList()
     }
     );
  };
  handleOnClickRAFRNextPage = () => {
    const { RAFRLimit, activePageRAFR } = this.state;
    const updateActivePage = activePageRAFR + 1;
    const updateOffset = updateActivePage * RAFRLimit - RAFRLimit;
    this.setState({
      RAFROffset: updateOffset,
      activePageRAFR: updateActivePage
    },
    ()=>{
      this.handleGetMultimodeRateComparisonViewDetailsRailFreightRateList()
    });
  };

  handleToggleForMoreFilterBtn = () => {
    this.setState((prevState) => {
      const updateState = { ...prevState };
      updateState.isMoreFilterOpen = !prevState.isMoreFilterOpen;
      return updateState;
    });
  };

  shouldRenderFreightInformationCard = () => {
    const { lowestFreight } = this.props;
    const C1 = !!lowestFreight.from;
    if (C1) {
      return true;
    }
    return false;
  };

  handleOnClickForVehicleName = (roadFreight = {}) => {
    this.setState((previousState) => {
      const updateState = {
        ...previousState,
      };
      updateState.selectedRoadFreight = roadFreight;
      return updateState;
    });
    this.handleModalPopupOpen()
  }

  handleModalPopupOpen = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: true,
      };
      return updatepreviousState;
    });
  };

  handleModalPopupClose = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: false,
      };
      return updatepreviousState;
    });
  };
  handleOpenDetailedCalculationModalPopup= () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isDetailedCalculationModalPopupOpen: true,
      };
      return updatepreviousState;
    });
  };
  handleCloseDetailedCalculationModalPopup= () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isDetailedCalculationModalPopupOpen: false,
      };
      return updatepreviousState;
    });
  };
  render() {
    const {
      loaderT1,
      source,
      destination,
      commodityCategories,
      freightDays,
      vehicleDetails,
      roadFreight,
      railFreightBcn,
      viewDetailsRoadFreight,
      viewDetailsRailFreightBcn,
      wagonTypes,
      railRakeList,
      lowestFreight,
      originYardList,
      destinationYardList,
    } = this.props;

    const {
      isAccordionOpen,
      filterQueryParams,
      avgFreight,
      vehicleType,
      wagonType,
      railRake,
      isMoreFilterOpen,
      originYard,
      destinationYard,
      commodityCategory,
      isModalPopupOpen,
      selectedRoadFreight,
      isDetailedCalculationModalPopupOpen,
    } = this.state;
    console.log("this.state:", this.state);

    return (
      <Fragment>
        {loaderT1 && <ActionBlurLoader />}
        <ModalT1
          isOpenState={isModalPopupOpen}
          handleOnClickForClose={this.handleModalPopupClose}
        >
          <ModalCardT1 title={"Bid Details"} >
            <BidDetailsTableInformation
              bid_record_details={selectedRoadFreight.bid_record_details}
            />

          </ModalCardT1>
        </ModalT1>
        <ModalT1
          isOpenState={isDetailedCalculationModalPopupOpen}
          handleOnClickForClose={this.handleCloseDetailedCalculationModalPopup}
        >
          <ModalCardT1 >
           <DetailedCalculationForFreight />
          </ModalCardT1>
        </ModalT1>
        <Sticky>
          <PageWrapperT2>
            <BackButtonT1 onClick={this.handleOnClickBack} />
            <Spacer spacing={"10px"} />
            <FilterBox
              filterQueryParams={filterQueryParams}
              fromList={source}
              toList={destination}
              commodityCategoryList={commodityCategories}
              handleOnChangeCommodityCategory={
                this.handleOnChangeCommodityCategory
              }
              handleFilterBoxOnChange={this.handleFilterBoxOnChange}
              handleOnClickForFilterBoxSearchButton={
                this.handleOnClickForFilterBoxSearchButton
              }
              isMoreFilterOpen={isMoreFilterOpen}
              handleToggleForMoreFilterBtn={this.handleToggleForMoreFilterBtn}
              freightDays={freightDays}
              avgFreight={avgFreight}
              handleOnChangeAvgFreight={this.handleOnChangeAvgFreight}
              vehicleDetails={vehicleDetails}
              vehicleType={vehicleType}
              handleOnChangeVehicleType={this.handleOnChangeVehicleType}
              wagonTypes={wagonTypes}
              wagonType={wagonType}
              handleOnChangeWagonType={this.handleOnChangeWagonType}
              railRakeList={railRakeList}
              railRake={railRake}
              handleOnChangeRailRake={this.handleOnChangeRailRake}
              originYardList={originYardList}
              destinationYardList={destinationYardList}
              originYard={originYard}
              destinationYard={destinationYard}
              handleOnChangeOriginYard={this.handleOnChangeOriginYard}
              handleOnChangeDestinationYard={this.handleOnChangeDestinationYard}
              commodityCategory={commodityCategory}
            />
            <Spacer spacing={"10px"} />
            {this.shouldRenderFreightInformationCard() ? (
              <FreightInformationCard lowestFreight={lowestFreight} />
            ) : (
              <Message />
            )}
            <Spacer spacing={"7px"} />
            <div className="mr-15">
              <PaginationButtons
                handleOnClickNextPage={this.handleOnClickNextPage}
                handleOnClickPreviousPage={this.handleOnClickPreviousPage}
              />
            </div>
            <Spacer spacing={"3px"} />
            <RateComparisonTable
              roadFreight={roadFreight}
              railFreightBcn={railFreightBcn}
              handleOnClickForRateComparisonTableItems={
                this.handleOnClickForRateComparisonTableItems
              }
              handleOnClickForVehicleName={this.handleOnClickForVehicleName}
            />
            <Spacer spacing={"10px"} />
            <ViewDetailsAccordion
              isAccordionOpen={isAccordionOpen}
              toggleAccordionOpenClose={this.toggleAccordionOpenClose}
              viewDetailsRoadFreight={viewDetailsRoadFreight}
              viewDetailsRailFreightBcn={viewDetailsRailFreightBcn}
              // freightDays={freightDays}
              // avgFreight={avgFreight}
              // handleOnChangeAvgFreight={this.handleOnChangeAvgFreight}
              // vehicleDetails={vehicleDetails}
              // vehicleType={vehicleType}
              // handleOnChangeVehicleType={this.handleOnChangeVehicleType}
              // wagonTypes={wagonTypes}
              // wagonType={wagonType}
              // handleOnChangeWagonType={this.handleOnChangeWagonType}
              // railRakeList={railRakeList}
              // railRake={railRake}
              // handleOnChangeRailRake={this.handleOnChangeRailRake}
              handleOnClickForVehicleName={this.handleOnClickForVehicleName}
              handleOnClickRFRNextPage = {this.handleOnClickRFRNextPage}
              handleOnClickRFRPreviousPage = {this.handleOnClickRFRPreviousPage}
              handleOnClickRAFRNextPage = {this.handleOnClickRAFRNextPage}
              handleOnClickRAFRPreviousPage = {this.handleOnClickRAFRPreviousPage}
            />
          </PageWrapperT2>
        </Sticky>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loaderT1: !!state.common.loaderT1,
    source: state.rateComparison.source,
    destination: state.rateComparison.destination,
    commodityCategories: state.rateComparison.commodityCategories,
    freightDays: state.rateComparison.freightDays,
    vehicleDetails: state.rateComparison.vehicleDetails,
    roadFreight: state.rateComparison.roadFreight,
    railFreightBcn: state.rateComparison.railFreightBcn,
    viewDetailsRoadFreight: state.rateComparison.viewDetailsRoadFreight,
    viewDetailsRailFreightBcn: state.rateComparison.viewDetailsRailFreightBcn,
    wagonTypes: state.rateComparison.wagonTypes,
    railRakeList: state.rateComparison.railRakeList,
    lowestFreight: state.rateComparison.lowestFreight,
    originYardList: state.rateComparison.originYardList,
    destinationYardList: state.rateComparison.destinationYardList,
  };
};

export default connect(mapStateToProps)(withRouter(MultimodalRateComparison));
